<template>
     <v-dialog v-model="packageToDelete.modalPopup" max-width="586px" min-height="800px" class="modal">
         <v-card>
             <v-card-title class="headline">
                <a v-on:click='closeModal' class="right"> <span class="icon-close right"></span> </a>
                <span class="cardheader">{{$t('InsuranceAPI.ApiKeys.DELETE_API_KEY_POPUP_TITLE', { packageToDelete: packageToDelete.code })}}</span>
            </v-card-title>
            <v-card-text class="carddeleteapikey">
                <span>{{this.packageToDelete.key}}</span>
                <br/>
                <span>
                    {{$t('InsuranceAPI.ApiKeys.DELETE_API_KEY_POPUP_DESC')}}
                </span>
            </v-card-text>
            <v-card-actions>
                <div class="cardactions">
                    <v-btn @click="deleteApikey(packageToDelete.code, packageToDelete.key)" color="primary" >{{$t('InsuranceAPI.ApiKeys.DELETE_KEY_BTN')}}</v-btn>
                    <v-btn @click="closeModal" >{{$t('InsuranceAPI.ApiKeys.CANCEL_KEY_BTN')}}</v-btn>
                </div>
            </v-card-actions>
         </v-card>
     </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import accountApi from '@/services/AccountApi'
import authApi from '@/services/Auth'
export default {
  data () {
    return {
      snackbar: {
        show: false,
        color: 'success',
        text: this.$t('InsuranceAPI.ApiKeys.API_KEYS_DELETED_DESC'),
        timeout: 6000
      }
    }
  },
  methods: {
    closeModal () {
      this.packageToDelete.modalPopup = false
      this.$store.dispatch('userdetails/setPackageToDelete', this.packageToDelete)
    },
    async deleteApikey (packageName, packageKey) {
      let success = await accountApi.deleteApikey(packageKey)
      if (success) {
        this.setSnackbarValues(true, 'success', this.$t('InsuranceAPI.ApiKeys.API_KEYS_DELETED_DESC'))
        this.$store.dispatch('global/setSnackbar', this.snackbar)

        if (packageName.toLowerCase() === 'Account'.toLowerCase()) {
          await authApi.refreshUserPackagesStorageWhenDeleteAccountApiKey(packageKey)
        } else {
          await authApi.refreshUserPackagesStorage()
        }

        await this.$store.dispatch('userdetails/loadUserPackages')
        this.packageToDelete.modalPopup = false
        this.$store.dispatch('userdetails/setPackageToDelete', this.packageToDelete)
      } else {
        this.setSnackbarValues(true, 'error', this.$t('InsuranceAPI.ApiKeys.API_KEY_DELETED_ERROR'))
        this.$store.dispatch('global/setSnackbar', this.snackbar)
      }
    },
    setSnackbarValues (show, color, text) {
      this.snackbar.show = show
      this.snackbar.color = color
      this.snackbar.text = text
    }
  },
  computed: {
    ...mapState('userdetails', ['packageToDelete'])
  }
}
</script>
